import { ReactNode } from "react";
import { MenuButton } from "@narmi/design_system";
import { catcat as cc } from "cerulean";

import styles from "./MenuItemSelector.module.scss";

export interface MenuItemSelectorOption {
  value: string;
  label: string;
}

export interface MenuItemSelectorProps {
  options: MenuItemSelectorOption[];
  selected: string;
  onSelect: (value: string) => void;
  label?: ReactNode;
  labelIcon?: string;
}

const MenuItemSelector = ({
  options,
  selected,
  onSelect,
  labelIcon,
  label = "Select",
}: MenuItemSelectorProps): JSX.Element => {
  const selectedOption = options.find((opt) => opt.value === selected);
  const triggerLabel = selectedOption ? selectedOption.label : label;

  return (
    <MenuButton
      label={label}
      showDropdownIndicator
      alignment="end"
      renderTrigger={(isOpen: boolean) => (
        <span className={styles.trigger}>
          {labelIcon && <span className={cc([labelIcon, styles.labelIcon])} />}
          {triggerLabel}
          <span
            className={cc([
              `narmi-icon-chevron-${isOpen ? "up" : "down"}`,
              styles.chevron,
            ])}
          />
        </span>
      )}
    >
      {options.map((opt) => (
        <MenuButton.Item
          key={opt.value}
          label={opt.label}
          onSelect={() => onSelect(opt.value)}
          endIcon={opt.value === selected ? "check" : undefined}
        />
      ))}
    </MenuButton>
  );
};

export default MenuItemSelector;
